import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAddressBook,
  faArrowLeft,
  faBalanceScale,
  faCalendar,
  faCamera,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faCaretUp,
  faCaretDown,
  faCaretRight,
  faForward,
  faCaretLeft,
  faBackward,
  faCopy,
  faEdit,
  faEllipsisH,
  faExclamationTriangle,
  faFlag,
  faList,
  faLock,
  faMapMarkerAlt,
  faMoneyCheckAlt,
  faPhoneAlt,
  faQuestionCircle,
  faSearch,
  faShoppingCart,
  faStore,
  faSync,
  faTh,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faTruck,
  faUserSecret,
  faWarehouse,
  faBug,
  faStar,
  faMoneyBillAlt,
  faClock,
  faPlus,
  faBox,
  faPrint,
  faComment,
  faCompress,
  faRetweet,
  faEyeSlash,
  faEye,
  faInfoCircle,
  faLifeRing,
  faEnvelope,
  faFolderOpen,
  faLayerGroup,
} from "@fortawesome/free-solid-svg-icons";

import {
  faHandshake,
  faTrashAlt as faTrash,
  faEdit as farEdit,
  faStar as farStar,
  faMoneyBillAlt as farMoneyBillAlt,
} from "@fortawesome/free-regular-svg-icons";

const initialize = (vue) => {
  library.add(
    faPrint,
    faBox,
    faAddressBook,
    faArrowLeft,
    faBalanceScale,
    faCalendar,
    faCamera,
    faCheckCircle,
    faChevronLeft,
    faChevronRight,
    faCaretUp,
    faCaretDown,
    faCaretRight,
    faForward,
    faCaretLeft,
    faBackward,
    faCopy,
    faEdit,
    faEllipsisH,
    faExclamationTriangle,
    faFlag,
    faHandshake,
    faList,
    faLock,
    faMapMarkerAlt,
    faMoneyCheckAlt,
    faPhoneAlt,
    faQuestionCircle,
    faSearch,
    faShoppingCart,
    faStore,
    faSync,
    faTh,
    faTimes,
    faTimesCircle,
    faTrashAlt,
    faTruck,
    faUserSecret,
    faWarehouse,
    faBug,
    faTrash,
    farEdit,
    faStar,
    farStar,
    faMoneyBillAlt,
    farMoneyBillAlt,
    faClock,
    faPlus,
    faComment,
    faCompress,
    faRetweet,
    faEyeSlash,
    faEye,
    faInfoCircle,
    faLifeRing,
    faEnvelope,
    faFolderOpen,
    faLayerGroup
  );
  vue.component("font-awesome-icon", FontAwesomeIcon);
};

export default initialize;
